import React from 'react';
import './ProofBar.css';

const stats = [
  { big: '10hrs', desc: 'saved per week on average (Zapier)' },
  { big: '21\u00D7', desc: 'more likely to qualify leads with fast response (HBR)' },
  { big: '2\u00D7', desc: 'faster payments with automated invoicing (Xero)' },
  { big: '78%', desc: 'of customers buy from the first responder (Lead Connect)' },
  { big: '250%', desc: 'average first-year ROI from automation (Nucleus Research)' },
];

const ProofBar: React.FC = () => {
  return (
    <div className="proof-bar">
      <div className="proof-bar-inner">
        {stats.map((s, i) => (
          <React.Fragment key={i}>
            {i > 0 && <div className="proof-divider" />}
            <div className="proof-stat">
              <span className="proof-big">{s.big}</span>
              <span className="proof-desc">{s.desc}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProofBar;
